import type { FreeV1 } from "./free/V1.schema";
import type { BaseV1 } from "./base/V1.schema";
import { FreeV2Schema } from "./free/V2.schema";
import type { z } from "zod";
import { Schemas } from "./schemas";
import type { VersionId } from "./schemas";
import { BaseV2Schema } from "./base/V2.schema";
import { ProV2Schema } from "./pro/V2.schema";
import type { ProV1 } from "./pro/V1.schema";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type MigrationFn = (_input: any) => any;


// FreeV1 -> FreeV2
function migrateFreeV1toV2(config: FreeV1): z.infer<typeof FreeV2Schema> {
    console.info(`Migrating Configuration FREE from V1 to V2`);
    const partial = {
        plan: "free",
        version: "free@2",
        private: config.private ?? {}, // private remains the same
        public: {
            ...config.public,
            languages: ["en-GB"]
        }
    };
    return FreeV2Schema.parse(partial);
}

// BaseV1 -> BaseV2
function migrateBaseV1toV2(config: BaseV1): z.infer<typeof BaseV2Schema> {
    console.info(`Migrating Configuration BASE from V1 to V2`);
    const partial = {
        plan: "base",
        version: "base@2",
        lastUpdated: config.lastUpdated,
        addons: config.addons,
        private: {
            origin: config.private.origin,
            authentication: config.private.authentication,
            security: {
                ...config.private.security,
                requirePreAuthorisation: false
            }
        },
        public: {
            ...config.public,
            languages: ["en-GB"]
        }
    };
    return BaseV2Schema.parse(partial);
}

// ProV1 -> ProV2
function migrateProV1toV2(config: ProV1): z.infer<typeof ProV2Schema> {
    console.info(`Migrating Configuration PRO from V1 to V2`);
    const partial = {
        plan: "pro",
        version: "pro@2",
        lastUpdated: config.lastUpdated,
        addons: config.addons,
        private: {
            origin: config.private.origin,
            authentication: config.private.authentication,
            security: {
                ...config.private.security,
                requirePreAuthorisation: false
            }
        },
        public: {
            ...config.public,
            languages: ["en-GB"]
        }
    };
    return ProV2Schema.parse(partial);
}

export const Migrations: Record<VersionId, MigrationFn> = {
    "free@1": (config) => {
        const v2 = migrateFreeV1toV2(config);
        return Migrations["free@2"](v2);
    },
    "free@2": (config) => Schemas["free@2"].parse(config),
    "base@1": (config) => {
        const v2 = migrateBaseV1toV2(config);
        return Migrations["base@2"](v2);
    },
    "base@2": (config) => Schemas["base@2"].parse(config),
    "pro@1": (config) => {
        const v2 = migrateProV1toV2(config);
        return Migrations["pro@2"](v2);
    },
    "pro@2": (config) => Schemas["pro@2"].parse(config),
};